type PageWrapperProps = {
  children: React.ReactNode;
  padding?: boolean;
  classNames?: string;
  overrideClassNames?: boolean;
  fixedHeight?: boolean;
  id?: string;
}

const PageWrapper = ({children, padding = true, id, classNames, overrideClassNames, fixedHeight}: PageWrapperProps) => {
  
  const className = overrideClassNames ? classNames || '' : `item-list no-gap ${classNames || ''}`;
  
  return (
    <main id={id} data-padding={padding} className={className} data-fixed-height={fixedHeight}>
      {children}
    </main>
  )
}
export default PageWrapper;